import resolveTimeUnit from '@/utils/resolveTimeUnit';
import { useMemo, useState } from 'react';

export default function useUnstable_LockPeriod(vaults = [], currency, labels = {}) {
  const lockPeriods = useMemo(() => {
    const visited = new Set();
    const list = [];
    for (const vault of vaults) {
      const { lock_in_period_seconds } = vault;
      if (visited.has(lock_in_period_seconds) || vault?.currency_id !== currency) continue;

      visited.add(lock_in_period_seconds);

      const { label, number } = resolveTimeUnit(lock_in_period_seconds);
      list.push({ label: number === 0 ? labels[label] : `${number} ${labels[label]}`, value: lock_in_period_seconds });
    }
    return list.sort((a, b) => a.value - b.value);
  }, [vaults, currency]);

  const [lockPeriod, setLockPeriod] = useState(lockPeriods?.[0]?.value);

  return { lockPeriods, setLockPeriod, lockPeriod };
}
